import { Koi } from '@ksyos/koi';
import type { Uuid } from '@common/utils/uuid';
import { ServiceCode } from '@common/enums';
import { ServiceType } from '@common/enums/serviceType';

export const baseValidationSchema = Koi.object({
    fundingForActivityCodes: Koi.array().required().min(1).items(Koi.string()),
    invoiceServiceCode: Koi.koi().enum(ServiceCode).required().allow(null),
    invoiceServiceName: Koi.string().max(255).required().allow(null),
    invoiceServiceType: Koi.koi().enum(ServiceType).required().allow(null),
    name: Koi.string().required().max(255),
});

export const createValidationSchema = baseValidationSchema
    .concat(
        Koi.object({
            serviceId: Koi.string().uuid().required(),
        })
    )
    .options({ convert: false, presence: 'required' });

export type BaseFundingServicePartMessage = {
    fundingForActivityCodes: string[];
    invoiceServiceCode: ServiceCode | null;
    invoiceServiceName: string | null;
    invoiceServiceType: ServiceType | null;
    name: string;
};

export type CreateFundingServicePartMessage = {
    serviceId: Uuid;
} & BaseFundingServicePartMessage;
